import { Component } from '@angular/core';

@Component({
  selector: 'app-orgautomations',
  templateUrl: './orgautomations.component.html',
  styleUrl: './orgautomations.component.css'
})
export class OrgautomationsComponent {

}
